import { appConfig } from "src/config";
import { isDevMode } from "./userSegment/features";

export const getMeristemConfigValue = (key: string) => {
  const { meristemConfig } = appConfig;

  // In dev mode, also check the URL for the key for easier local testing.
  if (isDevMode()) {
    // If urlParamValue is anything other than "false", its evaluated as truthy by callers.
    const urlParamValue = new URLSearchParams(window.location.search).get(key);
    if (urlParamValue === "false") return false;
    if (urlParamValue) return urlParamValue;
  }

  return meristemConfig[key];
};
